import * as React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { SectionIcon, SectionType } from "source/components/framework/Icon/SectionIcon";
import { AppReportTaskTypeTaskReference } from "ui/Scripts/source/models/appReportTemplate/appReportTaskTypeTaskReference";
import { TaskDynamicFormReferenceWarning } from "./TaskDynamicFormReferenceWarning";
import { Base } from "ui/Scripts/source/framework/base";

interface ITaskDynamicFormTaskReferenceProp {
    taskTypeCol: ITaskTypeCol;
}

export const TaskDynamicFormTaskReference = (props: ITaskDynamicFormTaskReferenceProp) => {
    const taskReference = new AppReportTaskTypeTaskReference(props.taskTypeCol.objectValue);

    return (
        <>
            <Divider sx={{
                "maxWidth": "100%",
                "overflow": "hidden",
                "&::before, &::after": {
                    borderColor: "#000"
                }
            }}>
                <Box sx={{ padding: "8px 0" }}>
                    <Tooltip title={taskReference.name}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <SectionIcon sx={{ marginRight: "8px" }} type={SectionType.Tasks} />
                            <span>{Translations.FormTaskReference}: </span>
                            <Box component="span" marginLeft="5px">
                                {(taskReference.taskTypeId && taskReference.dateField && taskReference.taskTypeChart.groupingFields.length > 0 && taskReference.taskTypeChart.valueFields.length > 0
                                    ? taskReference.name
                                    : <Typography color="red">{"'" + Translations.NotSelected + "'"}</Typography>
                                )}
                            </Box>
                        </Box>
                    </Tooltip>
                </Box>
            </Divider>
            {!(taskReference.taskTypeId && taskReference.dateField && taskReference.taskTypeChart.groupingFields.length > 0 && taskReference.taskTypeChart.valueFields.length > 0) &&
                <TaskDynamicFormReferenceWarning
                    message={String.format(Translations.FormTaskReferenceWarning,
                        Base.getStringWithSeparators([
                            taskReference.taskTypeId ? null : Translations.TaskType,
                            taskReference.dateField ? null : Translations.DateField,
                            taskReference.taskTypeChart.groupingFields.length > 0 ? null : Translations.ChartGroupingField,
                            taskReference.taskTypeChart.valueFields.length > 0 ? null : Translations.ChartValueFields
                        ], ", "))}
                />
            }
        </>
    );
};